'use client';

import { useTranslations } from 'next-intl';
import { OptimizedImage } from '@/components/images';
import type { AppUpsellEntryPoint } from '@/config/app-upsells';
import { AppPhone } from './app-phone';
import { AppStoreLinks } from './app-store-links';

import { useUpsellImpression } from './use-upsell-impression';

export function AppUpsellSlide({
  entryPoint = 'feed',
}: {
  entryPoint?: AppUpsellEntryPoint;
}): React.ReactNode {
  const t = useTranslations('app_upsells');
  const surface = entryPoint === 'landing' ? 'landing' : 'feed';
  const ref = useUpsellImpression(surface, true, entryPoint);
  return (
    <div className="app-upsell-feed" ref={ref} data-testid="app-upsell-slide">
      <div className={'app-upsell-feed-copy'}>
        <div className="flex min-w-0 flex-none items-center gap-3 text-foreground-primary md:flex-1 lg:flex-none">
          <div className="shrink-0 lg:absolute lg:top-6 lg:left-6">
            <OptimizedImage
              variant="thumbnail"
              src="/icons/morfi-logomark.svg"
              alt=""
              size="size-9"
              preview={false} // ALLOW-NO-PREVIEW: decorative app promotion artwork, not user-uploaded media
              // ALLOW-NSFW-FALSE: reviewed first-party app artwork, not user-uploaded media
              nsfw={false}
              loadReveal="none"
            />
          </div>
          <div className="min-w-0">
            <h2 className={'app-upsell-feed-title'}>{t('feed_title')}</h2>
          </div>
        </div>
        <AppStoreLinks
          surface={surface}
          entryPoint={entryPoint}
          location={entryPoint === 'landing' ? 'landing-banner' : 'feed'}
        />
      </div>
      <div className={'app-upsell-feed-art'}>
        <AppPhone />
      </div>
    </div>
  );
}
